// extracted by mini-css-extract-plugin
export var badlist = "basemdx-module--badlist--2e6b8";
export var destinfowrapper = "basemdx-module--destinfowrapper--6da3e";
export var goodlist = "basemdx-module--goodlist--30ef3";
export var imagestyle = "basemdx-module--imagestyle--2ab85";
export var infowrapper = "basemdx-module--infowrapper--47e6b";
export var middletable = "basemdx-module--middletable--5cf65";
export var olstyle = "basemdx-module--olstyle--1c2dc";
export var tablestyle = "basemdx-module--tablestyle--e2b8e";
export var title = "basemdx-module--title--29b63";
export var ulstyle = "basemdx-module--ulstyle--07e07";